import React ,{Component} from 'react';
import {NavLink,Navigate  } from 'react-router-dom';
import axios from 'axios';
import Button from '@mui/material/Button';
import { styled } from '@mui/system';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';
import TableSortLabel from '@mui/material/TableSortLabel';
import TablePagination from '@mui/material/TablePagination';
import TableBody from '@mui/material/TableBody'; 
import SettingsIcon from '@mui/icons-material/Settings';
import IosShareIcon from '@mui/icons-material/IosShare';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import dayjs from 'dayjs';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox'; 
import FormControlLabel from '@mui/material/FormControlLabel'; 
import { blueGrey } from '@mui/material/colors';
import {DragDropContext,Droppable,Draggable} from '@hello-pangea/dnd';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import DragHandleIcon from '@mui/icons-material/DragHandle';
import Sendemail from './Sendemailsalescreditnote';
import Tooltip from '@mui/material/Tooltip';
import ReactToPrint from 'react-to-print';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import EmailTwoToneIcon  from '@mui/icons-material/EmailTwoTone';
import ContentCopyTwoToneIcon from '@mui/icons-material/ContentCopyTwoTone';
import DeleteIcon from '@mui/icons-material/Delete';
import Columnsettings from './Columnsettings';
const useStyles = styled({   
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});
function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}
function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}
function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}
export default class Adminsalesinvoice extends Component {
    constructor(props) {
    super(props);
	var strdob = new Date();
var month = "";
if ((strdob.getMonth() + 1) < 10) {
    month = "0" + (strdob.getMonth() + 1);
} else {
    month = (strdob.getMonth() + 1);
}
const currentDate = new Date();
var month1 = (currentDate.getMonth() + 1 < 10) ? "0" + (currentDate.getMonth() + 1) : (currentDate.getMonth() + 1);
var lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
var lastDay = (lastDayOfMonth.getDate() < 10) ? "0" + lastDayOfMonth.getDate() : lastDayOfMonth.getDate();
 this.state = { 
 sestatus:'',isselectdisplay:false,quotenumber:'',open:false,
	 todate1: currentDate.getFullYear() + '-' + month1 + '-' + lastDay, todate: lastDayOfMonth,
fromdate: new Date(currentDate.getFullYear(), currentDate.getMonth(), 1),
 fromdate1:currentDate.getFullYear() + '-' + month1 + '-' + '01',company:'',se_quotenumber:'',
redirect:false,pagename:'',CustomerData:[] ,id:'',page:0 ,prevpage:0,totaldata:0,rowsPerPage:50,rowsPaging:[],
search:'',order:'desc' ,orderBy:'scn_id',
	 CreditnoteData:[],ColumnData:[],disablecopyicon:true,scnideis:'',iconslist:false,allchecked:false,colcount:0,totalrecords:0,selectedcount:0,exportaData:[],
	}
	 this.updateColumnssetting=this.updateColumnssetting;      
	}
	updateColumnssetting = (text) => {
this.ColumheaderinvoiceApi();
	}
 myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val});
 } 
componentWillMount() {
	document.title = "Isifol - Sales Credit Notes";
if(localStorage.getItem("ISIuserid")==null)
		  {
		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
else
{	
if(localStorage.getItem("ISIrole")==="1" || localStorage.getItem("ISIrole")==="2")
		  {
			 this.apicall(this.state.page,this.state.rowsPerPage);    
		  }
		  else{
		this.PageAccessCheckApi();
		  }
	}
		  	  let strname="Sales Credit Notes";
	 this.props.parentdasCallback(
            strname+"~"
        );
}
PageAccessCheckApi() {
  axios.get(localStorage.getItem("ISIurl")+'ajaxpagemaster.php?action=getbyuser&us_id='+localStorage.getItem('ISIuserid')+'&up_pm_id=3')
  .then(resp => {
	  let strreturn=resp.data;
      if (strreturn!==0) {
        this.apicall(this.state.page,this.state.rowsPerPage);    
      } else {
        this.setState({redirect: true,pagename: "/Accesspagemessage"});
      }
  });
}
apicall(page,rowsPerPage){
	let startIndex = page * rowsPerPage;
	axios.get(localStorage.getItem("ISIurl")+'ajaxsalescreditnote.php?action=getall&scn_status='+this.state.sestatus+'&fromdate='+this.state.fromdate1+'&todate='+this.state.todate1+'&scn_quotenumber='+this.state.quotenumber+'&StartIndex='+startIndex+'&PageSize='+rowsPerPage+'&scn_cmp_id='+localStorage.getItem("ISIcmpid"))
  .then(resp => {  	
    if(resp.data.length>0){
		let copy=[50, 100, 150, 200, 250];
			this.setState({  
			  CreditnoteData: resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			   rowsPaging:[],rowsPaging:copy,
               totalrecords:parseInt(resp.data[0].count),				   
			});
     }
	  else{
		   this.setState({CreditnoteData:[],totaldata:0});
	 }
  this.ColumheaderinvoiceApi();
    });
}
GetexportaData(id){
	axios.get(localStorage.getItem("ISIurl")+'ajaxsalescreditnote.php?action=getall&scn_id='+id)
  .then(resp => {  	
    if(resp.data.length>0){
			this.setState({  
			  exportaData: resp.data,
			});
     }
	  else{
		   this.setState({exportaData:[]});
	 }
    });
}
ColumheaderinvoiceApi(){
	axios.get(localStorage.getItem("ISIurl")+'ajaxcolumnconfigure.php?action=getall&cc_userid='+localStorage.getItem("ISIuserid")+'&cc_page=3&cc_isdisplay=1')
  .then(resp => {  	
    if(resp.data.length>0){
			this.setState({  
			  ColumnData: resp.data,  
			  colcount:parseInt(resp.data[0].count),
			});
     }
	  else{
		   axios.get(localStorage.getItem("ISIurl")+'ajaxcolumnconfigure.php?action=getall&cc_userid=0&cc_page=3&cc_isdisplay=1')
  .then(resp => {  	
				if(resp.data.length>0){
						this.setState({  
						  ColumnData: resp.data,  
						    colcount:parseInt(resp.data[0].count),
						});
				 }
	     });
	 }
    });
}
handleClickSearch=()=>{
 this.setState({page:0},()=>{
   this.apicall(0,this.state.rowsPerPage);
 });
}
handleChangePage = (event, newPage) => {  
    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage);  });
  }; 
   handleChangeRowsPerPage = event => {  
    let pageval = event.target.value;
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); }); 
  };
CloseMoreoption = (date) =>{
	this.setState({isselectdisplay:false});
}
fromdatehandler = (date) => {
    var month = "";
    var dateObj = new Date(date);
       if ((dateObj.getMonth() + 1) < 10) {
        month = "0" + (dateObj.getMonth() + 1);
    } else {
        month = (dateObj.getMonth() + 1);
    }
    this.setState({
        fromdate: dayjs(dateObj),
        fromdate1: dateObj.getFullYear() + '-' + month + '-' + dateObj.getDate()
    });
}
  toatehandler = (date) => {
    var month = "";
    var dateObj = new Date(date);
       if ((dateObj.getMonth() + 1) < 10) {
        month = "0" + (dateObj.getMonth() + 1);
    } else {
        month = (dateObj.getMonth() + 1);
    }
 this.setState({
        todate: dayjs(dateObj),
        todate1: dateObj.getFullYear() + '-' + month + '-' + dateObj.getDate()
    });
  }
	handleOpen = () => {
    this.setState({ open: true });
  };
handleClickOpen = (e) => { 
  this.setState({open:!this.state.open,
	  });
};
  Handleclickviewmore= (e) =>{
	  this.setState({isselectdisplay:true});
  }
 addcheckbox(){
    setTimeout(() => this.refs.Columnsettings.handleClickOpen(),500);
	  }
   HandleAllcheckbox=()=>{
           this.setState({iconslist:true});
         var studArray = this.state.CreditnoteData;
         const updatedArray = [...this.state.CreditnoteData];
         console.log('bulkdata',updatedArray);
         this.setState({allchecked:!this.state.allchecked},() => {
             if(this.state.allchecked===false)
                 {
                 var subnewRow=studArray.map((rowssub,j) => {
                                         updatedArray[j].isseleceted = "0" ;
                                 });
                            this.setState({iconslist:false});                
                  }
                 else if(this.state.allchecked===true)
                         {
                                  var subnewRow = studArray.map((rowssub, j) => {
                                   updatedArray[j].isseleceted = "1" ;
                           });
                         }
                        this.setState({CreditnoteData:updatedArray,},()=>{
                        const selectedItems= this.state.CreditnoteData.filter(item => item.isseleceted==="1")
                 this.setState({selectedcount:selectedItems.length}); 
                  const selectedIds = selectedItems.map(item => item.scn_id);
                  const selectedIdsString = selectedIds.join(',');
                  this.setState({scnideis:selectedIdsString},()=>{
                       this.GetexportaData(this.state.scnideis)  
                  },()=>{
                    if(this.state.scnideis!=="")
                          { 
                         this.setState({iconslist:true});
                          }
                          else
                          {
                                   this.setState({iconslist:false});
                          }
                  });   
                  if (selectedIds.length >= 2) {
         this.setState({disablecopyicon: false,});
         } 
                 else{
                         this.setState({disablecopyicon:true });
                 }
                        });
         }); 
  } 
  HandleCheckbox=(id,rowsd)=>{
  this.setState({iconslist:true});
  const updatedArray=[...this.state.CreditnoteData];
          if(updatedArray[rowsd].isseleceted==="0")
          {
                  updatedArray[rowsd].isseleceted = "1" ;
                    console.log('check',updatedArray);
          }
          else
          {
          updatedArray[rowsd].isseleceted = "0" ;
           console.log('unchcek',updatedArray);
      }
          this.setState({CreditnoteData: updatedArray,},()=>{
                 const selectedItems= this.state.CreditnoteData.filter(item => item.isseleceted==="1")
				  this.setState({selectedcount:selectedItems.length}); 
                  const selectedIds = selectedItems.map(item => item.scn_id);
                  const selectedIdsString = selectedIds.join(',');
                  this.setState({scnideis:selectedIdsString},()=>{
                          if(this.state.scnideis!=="")
                          {
                         this.setState({iconslist:true});
						  this.GetexportaData(this.state.scnideis)
                          }
                          else
                          {
                                   this.setState({iconslist:false});
                          }
                  });
                 if (selectedItems.length >= 2) {
         this.setState({disablecopyicon: false });
         } 
                 else{
                         this.setState({disablecopyicon: true });
                 }
          }) ;
  }
  onClickBulkdelete(){
	const idsArray = this.state.scnideis.split(",").filter(id=>id.trim() !==""); 
    const count = idsArray.length; 
    if (count === 0) {
   this.setState({errormessage:"You Have Not Checked any checkbox Please select any one",erropen:true,});
		 window.scrollTo({top: 0})
		 return false;
    return; 
  }
	  let r = window.confirm("Do you really want to Delete?");
		 if(r == true){
			  var formData = new FormData(); 
					 formData.append('action','delete')	
					 formData.append('scn_id',this.state.scnideis)
			         formData.append('userid',localStorage.getItem("ISIuserid"))
					  axios.post(localStorage.getItem("ISIurl")+"ajaxsalescreditnote.php", formData, {
						}).then(res =>{
							  this.apicall(this.state.page,this.state.rowsPerPage); 
						});
		 }
  }
	render()
	{
		 if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
		const { checkedvalues } = this.state;
		return(
		   <React.Fragment>
<div className="searchbox">
<ul>
 <li>
 <div className="iconlistprinttop">
<span className="countreconds">{this.state.selectedcount + " of " + this.state.totalrecords + " selected"}</span>
{this.state.iconslist===true && (
 <React.Fragment>
<Tooltip title="Print" placement="top">
  <IconButton>
  <LocalPrintshopIcon onClick={()=>{this.refs.PrintBox.handleClickPrint();}}/>
  </IconButton>
</Tooltip>
<Tooltip title="Email" placement="top">
  <IconButton>
  <EmailTwoToneIcon  onClick={()=>{  this.refs.Sendemail.handleaddfileClose()}}/>
  </IconButton>
</Tooltip>
{this.state.disablecopyicon === true && (
  <a href={'/#/AddSalescreditnotes?scnid='+this.state.scnideis+'&copy=1'} >
    <Tooltip title="Copy" placement="top">
      <IconButton>
        <ContentCopyTwoToneIcon />
      </IconButton>
    </Tooltip>
  </a>
)}
<Tooltip title="Delete" placement="top">
  <IconButton>
 <DeleteIcon onClick={()=>{this.onClickBulkdelete()}} />
  </IconButton>
</Tooltip>
 <Tooltip title="Export" placement="top">
  <ReactHTMLTableToExcel
    id="exportbtndisble"
    table="Creditnote"
    filename="Sales Credit Note Report"
    sheet="Sales Credit Note Report"
    buttonText= <IosShareIcon />
    style={{display:"none" }} 
  /> 
   <IconButton onClick={() => { this.GetexportaData(); }}>
  </IconButton>
</Tooltip>
 </React.Fragment>
)}
</div>
</li>
 <li>
        <p> <p>Search</p>
          <TextField
            variant="outlined"
            fullWidth
			className="txtbox"
            value={this.state.quotenumber}
            id="quotenumber"
            inputProps={{ tabIndex: "1", maxLength: 150 }}
            name="quotenumber"
            onChange={this.myChangeHandler}
            InputProps={{
              endAdornment: (
                <SearchOutlinedIcon style={{ marginLeft: 8 }} />
              ),
            }}
          />
        </p>
      </li>
<li>
<p><p>From Date</p>
<LocalizationProvider dateAdapter={AdapterDayjs}>
<DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.fromdate) }
className="txtbox"
    onChange={this.fromdatehandler} format="MM/DD/YYYY"
/>  </DemoContainer>
</LocalizationProvider></p>
</li>
<li>
<p><p>To Date</p>
<LocalizationProvider dateAdapter={AdapterDayjs}>
<DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.todate) }
className="txtbox"
onChange={this.toatehandler} format="MM/DD/YYYY"
/>  </DemoContainer>
    </LocalizationProvider> </p></li>
<li>
  <p>
    <Button
      type="submit"
      variant="outlined"
      className="morebtn"
      onClick={this.Handleclickviewmore}
    >
      More
   </Button> 
   <span className="closeincon">
   {this.state.isselectdisplay === true && (
      <CloseRoundedIcon onClick={this.CloseMoreoption} />
    )}
   </span>
  </p>
</li>
<li>
	 <p className="searchbutton">
       <Button
  type="submit"
  variant="contained"
  className="frmSecondarybtn"
  onClick={this.handleClickSearch}
>
  Search 
</Button>
      </p>
		</li>
</ul>
<PrintBox ref="PrintBox" childcols={this.state.ColumnData} scnideis={this.state.scnideis}/>
<Columnsettings 
ref="Columnsettings"  
pageval={3}
updateDonenew={this.updateColumnssetting}/>	
<ul>
	{this.state.isselectdisplay===true &&(
	<li>
<p>Status</p> <p><Select
  native
  variant="outlined" className="txtbox"
  margin="normal"
  fullWidth 
  onChange={this.myChangeHandler}
  id="role"
  value={this.state.sestatus}
  name="sestatus"
  inputProps={{tabIndex: "4"}}
        >
		  <option value={0}>All</option>
  <option value={1}>Draft</option>
  <option value={2}>Unpaid</option>
  <option value={3}>Partial Paid</option>
  <option value={4}>Paid</option>
  <option value={5}>Void</option>
  <option value={6}>Outstanding</option>	
  </Select></p>
</li>
	)}
</ul>
</div>	
	<div className="addandbacbtn"> <NavLink  to="/AddSalescreditnotes" className="frmSecondarybtn">New Credit</NavLink></div>				
	<div className="clear"></div>			
<div className="estimatebox">
<div onClick={this.handleOpen} className="ui-conatiner">
       <span className="congiguration" onClick={()=>{this.addcheckbox()}}>   <SettingsIcon /> </span>
        </div>
<Paper className={useStyles.root}>
<TableContainer className={useStyles.container}>  
<Table stickyHeader aria-label="sticky table"> 
 <TableHead>
          <TableRow>
            <TableCell>   
			<Checkbox 
           checked={this.state.allchecked}
           onChange={()=>{this.HandleAllcheckbox()}}
            inputProps={{ 'aria-label': 'controlled' }}
            sx={{
          color: 'white', 
         '&.Mui-checked': {
            color: 'white', 
        },
    }}
              /> 	
			</TableCell>
		   {this.state.ColumnData.map((cols,i) => {  
           return (
		    <TableCell>{cols.cc_displayname}</TableCell>
		   )
		  })}
          </TableRow>
        </TableHead>
  <TableBody>
{this.state.CreditnoteData.map((item,index) => {  
           return ( <React.Fragment>
 <TableRow key={index} >
	  <TableCell>{item.isseleceted==="0" && (
        <Checkbox
         onChange={()=>{this.HandleCheckbox(item.scn_id,index)}}
         inputProps={{ 'aria-label': 'controlled' }}
		      sx={{'&.Mui-checked': {
            color: 'gray', 
                },}}/> 
      )}{item.isseleceted==="1" && (
        <Checkbox
      checked       onChange={()=>{this.HandleCheckbox(item.scn_id,index)}}
      sx={{ '&.Mui-checked': {
            color: 'gray', 
            },}} /> 
     )}</TableCell>
{this.state.ColumnData.map((cols,i) => { 
	  let colsname	=  cols.cc_columnname; 
	  return ( <React.Fragment>
 {colsname!=="sin_file" &&(
<TableCell>
 <a className="link" href={"#/Salecreditnoteviewmore?scnoid="+item.scn_id+""}>{item[""+colsname+""]}</a></TableCell>
 )}
  {(colsname==="sin_file" ) &&(
	 <TableCell>
	 {( item.sin_file!=="") &&(
 <a className="link" href={localStorage.getItem("ISIurl")+"uploads/"+item.sin_file+""} target="_blank">View</a>
  )}
 </TableCell>
	 )}
			</React.Fragment>	);
					})}
 </TableRow>
				</React.Fragment>	
				);
					})}
{this.state.CreditnoteData.length===0 &&(					<TableRow key={0} >
<TableCell align="center" colSpan={this.state.colcount}>No Records</TableCell>
					</TableRow>
					) }
 </TableBody>
</Table>
  </TableContainer> 
  <TablePagination  
        rowsPerPageOptions={[50, 100, 150,200]}  
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onRowsPerPageChange={this.handleChangeRowsPerPage}  
      />    
  </Paper>
 </div>
<div style={{"display":"none"}}>
<Paper className={useStyles.root}>
  <TableContainer className={useStyles.container}>  
  <Table stickyHeader aria-label="sticky table" id="Creditnote">  
<TableHead> 
<TableRow>
          {this.state.ColumnData.map((cols,i) => {  
           return (
		    <TableCell>{cols.cc_displayname}</TableCell>
		   )
		  })}
                      </TableRow></TableHead>
                      <TableBody>
                     {stableSort(this.state.exportaData, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => {  
           return (
 <React.Fragment>
 <TableRow key={index} >
{this.state.ColumnData.map((cols,i) => { 
	  let colsname	=  cols.cc_columnname; 
	  return ( <React.Fragment>
 {colsname!=="scn_file" &&(
<TableCell>
{item[""+colsname+""]}</TableCell>
 )}
  {(colsname==="scn_file" ) &&(
	 <TableCell>
	 {( item.scn_file!=="") &&(
 <a className="link" href={localStorage.getItem("ISIurl")+"uploads/"+item.scn_file+""} target="_blank">View</a>
  )}
 </TableCell>
	 )}
			</React.Fragment>	);
					})}
 </TableRow>
 </React.Fragment>	
);
					})}
{this.state.CreditnoteData.length===0 &&(					<TableRow key={0} >
<TableCell align="center" colspan={this.state.colcount}>No Records</TableCell>
</TableRow>
					) }
 </TableBody>
</Table>
  </TableContainer> 
  </Paper>
</div>
<Sendemail ref="Sendemail" 
emailid={''}
 id={this.state.scnideis} 
 headingname="Sales Credit Note"
 adminname="Credit Notes"
  aoid="9"
 />
	   </React.Fragment>	
		)
	}
}


export class PrintBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      printopen: false,
	  creditArray:[],
    };
  }
 handleClickPrint = () => {
  this.GetSalecredinotesbyids(this.props.scnideis)
};
 GetSalecredinotesbyids(id){
axios.get(localStorage.getItem("ISIurl")+'ajaxsalescreditnote.php?action=getall&scn_id='+id)
  .then(resp => {  	
    if(resp.data.length>0){
			this.setState({  
			  creditArray: resp.data,  
			},()=>{
				 setTimeout(() =>
document.getElementById('print-button').click() 
,500);
			});
     }
	  else{
		   this.setState({creditArray:[]});
	 }
    });
}
  render() {
 return (
	 <React.Fragment>
	 <div className="printmod">
	<div ref={el => (this.componentRef = el)} >
<Paper className={useStyles.root}>
<TableContainer className={useStyles.container}>  
<Table stickyHeader aria-label="sticky table"> 
 <TableHead>
          <TableRow>
          {this.props.childcols.map((cols,i) => {  
           return (
		    <TableCell>{cols.cc_displayname}</TableCell>
		   )
		  })}
          </TableRow>
        </TableHead>
  <TableBody>
{this.state.creditArray.map((item,index) => {  
           return ( <React.Fragment>
 <TableRow key={index} >
{this.props.childcols.map((cols,i) => { 
	  let colsname	=  cols.cc_columnname; 
	  return ( <React.Fragment>
 {colsname!=="scn_file" &&(
<TableCell>
{item[""+colsname+""]}</TableCell>
 )}
  {(colsname==="scn_file" ) &&(
	 <TableCell>
	 {( item.scn_file!=="") &&(
 <a className="link" href={localStorage.getItem("ISIurl")+"uploads/"+item.scn_file+""} target="_blank">View</a>
  )}
 </TableCell>
	 )}
			</React.Fragment>	);
					})}
 </TableRow>
				</React.Fragment>	
				);
					})}
 </TableBody>
</Table>
  </TableContainer> 
  </Paper>
</div>
<ReactToPrint 
            trigger={() => <p id="print-button" className="Primarybuttons">Print </p>}
			content={() =>  this.componentRef} />
		</div>	
			 </React.Fragment>
 ) }
}